/* eslint-disable no-restricted-syntax */

import { createSelector } from 'reselect';
import { MAIN_DOMAIN, isOnDomainType } from '../../routesHelpers';
import { multiDomainRoutesMap } from '../../routesMap';
import { selectCurrentOrigin } from '../../location/selectors';

/* global _OL_ORIGIN */

const makeSelectOriginForActionWithDomainOptions = (domainOptions, action) => {
  if (
    domainOptions.domain === MAIN_DOMAIN &&
    !domainOptions.makeSelectOriginForAction
  ) {
    /**
     * For the main domain, transitions are allowed by default and they
     * obviously go to the main domain
     */
    return () => _OL_ORIGIN;
  }
  /**
   * For custom domains, the option must be set to determine which (if any)
   * custom domain is allowed
   */
  return domainOptions.makeSelectOriginForAction(action);
};

export const makeSelectOriginForAction = (action) => {
  // Return the origin that the given action should navigate to, given the current origin,
  // multiDomainRoutesMap, action, and state
  const multiDomainRoute = multiDomainRoutesMap[action.type];
  const { domains, stickyDomain } = multiDomainRoute;

  // If domains isn't specified, the default is [MAIN_DOMAIN]
  const effectiveDomains = domains || [MAIN_DOMAIN];

  const selectors = [];

  if (stickyDomain) {
    for (let domainOptions of effectiveDomains) {
      if (typeof domainOptions === 'string') {
        domainOptions = {
          domain: domainOptions,
        };
      }
      selectors.push(
        createSelector(
          [
            selectCurrentOrigin,
            makeSelectOriginForActionWithDomainOptions(domainOptions, action),
          ],
          (currentOrigin, originForActionWithDomainOptions) => {
            if (!isOnDomainType(currentOrigin, domainOptions.domain)) {
              return null;
            }
            return originForActionWithDomainOptions;
          }
        )
      );
    }
  }

  for (let domainOptions of effectiveDomains) {
    if (typeof domainOptions === 'string') {
      domainOptions = {
        domain: domainOptions,
      };
    }
    const selectOrigin = makeSelectOriginForActionWithDomainOptions(
      domainOptions,
      action
    );
    selectors.push(selectOrigin);
  }

  return (state) => {
    for (const selector of selectors) {
      const origin = selector(state);
      if (origin) {
        return origin;
      }
    }
    // eslint-disable-next-line no-console
    console.warn(
      '<Link />/makeSelectOriginForAction: Failed to get origin for action!',
      action
    );
    return null;
  };
};
